//Action Types
///masterpaymentprovider/list
export const GET_MASTER_PAYMENT_PROVIDER_LIST =
  "GET_MASTER_PAYMENT_PROVIDER_LIST";
export const GET_MASTER_PAYMENT_PROVIDER_LIST_SUCCESS =
  "GET_MASTER_PAYMENT_PROVIDER_LIST_SUCCESS";
export const GET_MASTER_PAYMENT_PROVIDER_LIST_FAIL =
  "GET_MASTER_PAYMENT_PROVIDER_LIST_FAIL";

///masterpaymentprovider/data
export const GET_MASTER_PAYMENT_PROVIDER_DATA =
  "GET_MASTER_PAYMENT_PROVIDER_DATA";
export const GET_MASTER_PAYMENT_PROVIDER_DATA_SUCCESS =
  "GET_MASTER_PAYMENT_PROVIDER_DATA_SUCCESS";
export const GET_MASTER_PAYMENT_PROVIDER_DATA_FAIL =
  "GET_MASTER_PAYMENT_PROVIDER_DATA_FAIL";

///masterpaymentprovider/create
export const CREATE_MASTER_PAYMENT_PROVIDER = "CREATE_MASTER_PAYMENT_PROVIDER";
export const CREATE_MASTER_PAYMENT_PROVIDER_SUCCESS =
  "CREATE_MASTER_PAYMENT_PROVIDER_SUCCESS";
export const CREATE_MASTER_PAYMENT_PROVIDER_FAIL =
  "CREATE_MASTER_PAYMENT_PROVIDER_FAIL";

///masterpaymentprovider/update
export const UPDATE_MASTER_PAYMENT_PROVIDER = "UPDATE_MASTER_PAYMENT_PROVIDER";
export const UPDATE_MASTER_PAYMENT_PROVIDER_SUCCESS =
  "UPDATE_MASTER_PAYMENT_PROVIDER_SUCCESS";
export const UPDATE_MASTER_PAYMENT_PROVIDER_FAIL =
  "UPDATE_MASTER_PAYMENT_PROVIDER_FAIL";

///masterpaymentprovider/delete
export const DELETE_MASTER_PAYMENT_PROVIDER = "DELETE_MASTER_PAYMENT_PROVIDER";
export const DELETE_MASTER_PAYMENT_PROVIDER_SUCCESS =
  "DELETE_MASTER_PAYMENT_PROVIDER_SUCCESS";
export const DELETE_MASTER_PAYMENT_PROVIDER_FAIL =
  "DELETE_MASTER_PAYMENT_PROVIDER_FAIL";
